// F5, fechar aba ou navegar pra fora cancela os fetch em andamento. Esse
// cancelamento chega como o mesmo TypeError de uma queda de rede, e cai no
// mesmo catch usado pra detectar sessao expirada (ver doLogout abaixo) - sem
// essa flag o usuario era deslogado so por atualizar a pagina no meio de um
// carregamento. Fica no escopo do modulo de proposito: o constructor roda a
// cada new Service(), o que registraria dezenas de listeners duplicados.
let paginaSaindo = false;
if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', () => {
    paginaSaindo = true;
  });
  window.addEventListener('pagehide', () => {
    paginaSaindo = true;
  });
}

export default class Service {
  constructor() {
    if (window.location.hostname === 'localhost') {
      //this.endPoint = 'https://api.blueexperiencias.com.br/api/';
      this.endPoint = `http://${window.location.hostname}:8080/api/`;
      this.endPointQuestionario = `http://${window.location.host}/blue/questionario`;
    } else {
      this.endPoint = 'https://api.blueexperiencias.com.br/api/';
      this.endPointQuestionario = `https://app.blueexperiencias.com.br/blue/questionario`;
    }
  }

  isLogged = () =>
    localStorage.getItem('token') !== null &&
    localStorage.getItem('token') !== 'null' &&
    localStorage.getItem('token') !== '';

  // Este doLogout e o "logout por falha": e o que os catch dos Service.js
  // chamam quando uma requisicao da errado. O logout explicito do usuario
  // (clique em "Sair") tem implementacao propria no Header e no Sidebar.
  doLogout = () => {
    // Navegacao em andamento (F5/fechar aba): as requisicoes canceladas caem
    // neste mesmo caminho. Nao deslogar - a pagina ja esta sendo descarregada.
    if (paginaSaindo) return;

    // A tela de login tambem chama doLogout no catch (Login/Service.js). Sem
    // esta guarda, API fora do ar recarregava o /login sem mostrar nada e a
    // mensagem de erro que ja existe em Login/index.js nunca aparecia.
    if (window.location.pathname === '/login') return;

    localStorage.setItem('token', 'null');
    localStorage.setItem('user', 'null');
    localStorage.removeItem('persist:root');

    window.location = '/login';
  };

  async getCEP(cep) {
    cep = cep.replace('.', '').replace('-', '');
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`, {
        method: 'get',
      });
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.error(error);
    }
  }

  acceptInvite = async body => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Convite`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout();
    }
  };

  userInvitation = async () => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Convite`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'text/plain',
        },
      });

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout();
    }
  };

  getCompany = async (tokenValue, arquivadas = false) => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Empresa${arquivadas ? '?arquivadas=true' : ''}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'text/plain',
        },
      });

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout();
    }
  };

  // GET Plano/{id} - funciona pra plano inativo tambem (diferente de
  // listActivePlans/Plano/ativos, que so devolve os ativos). Usado por
  // ReviewCompany pra buscar o plano/contrato da PROPRIA empresa, mesmo
  // quando e um plano personalizado (inativo de proposito).
  getPlano = async id => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Plano/${id}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'text/plain',
        },
      });

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout();
    }
  };

  listActivePlans = async () => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Plano/ativos`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'text/plain',
        },
      });

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout();
    }
  };

  aceitarContrato = async idVinculoPlano => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Empresa/${idVinculoPlano}/aceitarcontrato`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'application/json',
        },
      });

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout();
    }
  };

  recusarContrato = async idVinculoPlano => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Empresa/${idVinculoPlano}/recusarcontrato`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'application/json',
        },
      });

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout();
    }
  };

  // Estava duplicado ao pe da letra em Company/Service.js e
  // RegisterCompany/Service.js - os dois pontos de entrada admin que
  // criam um usuario "administrador" pra vincular a uma empresa nova.
  createUserForCompany = async ({ nome, email }) => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}User/administrador`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ nome, email }),
      });
      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
    }
  };

  getFilial = async (arquivadas = false) => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Filial${arquivadas ? '?arquivadas=true' : ''}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'text/plain',
        },
      });

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout();
    }
  };

  // Extraido de Login.manageClient (2026-08-12) pra ser reaproveitado tambem
  // pelo "Agora nao"/pos-aceite da tela de convites - decide se o usuario ja
  // tem empresa ou filial (vai pra /client) sem fazer o dispatch redux nem a
  // navegacao (essa classe nao tem acesso ao redux) - quem chama decide o
  // resto usando o resultado.
  decidirDestinoPosLogin = async () => {
    const getCompany = await this.getCompany();
    if (getCompany && getCompany.object && getCompany.object.length > 0) {
      // Empresa criada por um Administrador em nome desse usuario (2026-08-17) -
      // ContratoAceito so vem explicitamente false nesse caminho (o fluxo de
      // auto-cadastro sempre grava true, checkbox de Termos obrigatorio); checagem
      // estrita pra nunca capturar null/undefined de dado legado e bloquear
      // empresa nenhuma existente. Achado 2026-08-17: precisa varrer a lista
      // inteira, nao so object[0] - o usuario pode ja ter outra empresa antiga
      // (com contrato aceito) alem dessa nova pendente, e nesse caso a pendente
      // pode nao ser a primeira da lista.
      // podeAceitarContrato (2026-09-08): so o DONO da empresa - quem a teve
      // criada em seu nome pelo Administrador - pode ser mandado pra
      // /reviewCompany. Sem isso, QUALQUER pessoa com vinculo aceito na empresa
      // caia nessa tela enquanto o contrato estivesse pendente, incluindo um
      // convidado de unidade que so queria ver o convite dele. Foi o que
      // aconteceu com a empresa 331: o convidado aceitou o contrato no lugar do
      // dono (virou IdUsuarioAceite), gerou uma segunda linha em AceiteTermos, e
      // ainda por cima teve na tela um botao "Recusar" que APAGA a empresa
      // inteira. Ver EmpresaDto.PodeAceitarContrato no back.
      const empresaPendente = getCompany.object.find(
        e => e.contratoAceito === false && e.podeAceitarContrato === true
      );
      if (empresaPendente) {
        return {
          destino: '/reviewCompany',
          clientFilial: { selected: empresaPendente, filial: false },
        };
      }

      return {
        destino: '/client',
        clientFilial: { selected: getCompany.object[0], filial: false },
      };
    }

    const getFilial = await this.getFilial();
    if (getFilial && getFilial.object && getFilial.object.length > 0) {
      return {
        destino: '/client',
        clientFilial: { selected: getFilial.object[0], filial: true },
        getFilial,
      };
    }

    // Achado 2026-08-28: sem essa checagem, um cliente que arquiva o UNICO
    // grupo/unidade que tem perde o acesso pra sempre - GetEmpresas/GetFiliais
    // (acima, sem `arquivadas`) somem da lista de proposito (e o ponto do
    // arquivamento), mas cair no mesmo `destino: null` de "nunca completou o
    // cadastro" manda a pessoa pra tela de "conta quase pronta"
    // (cadastroEmpresaBloqueado, Home/index.js), que nao tem NENHUM link pra
    // Configuracoes - travava o usuario sem jeito de desarquivar e reverter
    // sozinho. Antes de desistir, confere se existe algo arquivado; se sim,
    // manda direto pra /settings (aba "Arquivados") em vez do bloqueio.
    const [getCompanyArquivada, getFilialArquivada] = await Promise.all([
      this.getCompany(undefined, true),
      this.getFilial(true),
    ]);
    const temArquivado =
      (getCompanyArquivada && getCompanyArquivada.object && getCompanyArquivada.object.length > 0) ||
      (getFilialArquivada && getFilialArquivada.object && getFilialArquivada.object.length > 0);

    if (temArquivado) {
      // abaInicial e' repassado pelos chamadores (Home/index.js,
      // postLoginNavigation.js) como parte do state da rota, e SettingsBlue
      // le no mount pra abrir direto na aba certa - achado 2026-08-28
      // (ultrareview): sem isso, o redirect chegava em /settings mas na aba
      // "Grupos e Unidades" (vazia, ja que tudo esta arquivado), nao na
      // "Arquivados" que o comentario acima promete.
      return {
        destino: '/settings',
        abaInicial: 'arquivados',
        clientFilial: { selected: {}, filial: false },
      };
    }

    // Nem empresa, nem filial - quem chamou decide entre '/register' (CPF
    // ainda vazio) e '/' usando boolCompleteRegister.
    return { destino: null };
  };

  getAppVersion = async () => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Versao`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'application/json',
        },
      });

      const json = await response.json();

      return json;
    } catch (err) {
      console.warn('Erro ao obter versão do aplicativo', err);
    }
  };

  getToken = () => localStorage.getItem('token');

  setToken = token => localStorage.setItem('token', token);

  getLoggedUser = () => JSON.parse(localStorage.getItem('user'));

  setLoggedUser = u => localStorage.setItem('user', JSON.stringify(u));

  getGruposUsuario = async () => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Empresa/listar-grupos-usuario`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'text/plain',
        },
      });

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout();
    }
  }

  listFilial = async (tokenValue) => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Filial`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'text/plain',
        },
      });

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout()
    }
  };

  getCompanyById = async (id) => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Empresa/${id}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'text/plain',
        },
      });

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout()
    }
  };

  getFilialId = async (id) => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Filial/${id}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'text/plain',
        },
      });

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout()
    }
  };
}
